import {Tooltip} from '@sketchpixy/rubix'
import * as React from 'react'
import _ from 'lodash'

export const ERROR_MESSAGES = {
    RESET_TOKEN_MISSING: 'Reset Password Token is Missing',
    POLLING_STATION_ERROR_MESSAGE : 'Polling Station is required',
    USER_ERROR_MESSAGE: 'Email is required',
    PASSWORD_ERROR_MESSAGE: 'Password is required',
    PASSWORD_MISMATCH: 'Passwords should be same',
    COMPARE_NEW_PASSWORD_MISMATCH: 'New and Confirm Passwords should be same',
    FIRST_NAME_ERROR_MESSAGE: 'First name is required',
    LAST_NAME_ERROR_MESSAGE: 'Last name is required',
    TIME_SLOTS_ERROR_MESSAGE: 'TimeSlots are required',
    PASSWORD_LENGTH_ERROR_MESSAGE: 'Password length must be equal or greater than 6',
    EMAIL_REQUIRED_ERROR: 'Email is required',
    EMAIL_PATTERN_ERROR: 'Email is not correct',
    PHONE_REQUIRED_ERROR: 'Phone is required',
    PHONE_PATTERN_ERROR: 'Phone number is invalid',
    ADDRESS_REQUIRED_ERROR: 'Address is required',
    STREET_REQUIRED_ERROR: 'Address Line 1 is required',
    CITY_REQUIRED_ERROR: 'City is required',
    STATE_REQUIRED_ERROR: 'State is required',
    ZIP_CODE_REQUIRED_ERROR: 'Zipcode is required',
    TIME_SLOT_REQUIRED_ERROR: 'Please check at least one Time Slot',
    TIME_SLOT_RIDER_REQUIRED_ERROR: 'Please check maximum one Time Slot',
    TIME_SLOT_DRIVER_REQUIRED_ERROR: 'Please check maximum two Time Slots',
    TIME_SLOT_DRIVER_DIFF_REQUIRED_ERROR: 'Please check consective two Time Slots',
    ROLE_ERROR: 'Please check at least one role',
    STATUS_ERROR: 'Please check at least one Status',
    NO_OF_RIDERS_ERROR: 'Allowed Riders are between 1-5',
    SCHOOL_NAME_ERROR: 'School name is required',
    LEGAL_NAME_ERROR: 'Legal name is required',
    MISSION_ERROR: 'School mission is required',
    WEBSITE_ERROR: 'Website is required',
    SUBDOMAIN_ERROR: 'SubDomain is required',
    VEHICLE_MAKE_ERROR: 'Make is required',
    VEHICLE_MODEL_ERROR: 'Model is required',
    VEHICLE_COLOR_ERROR: 'Color is required',
    VEHICLE_CAPACITY_ERROR: 'Capacity is required',
    VEHICLE_YEAR_ERROR: 'Year is required',
    VEHICLE_STATE_ERROR: 'State is required',
    VEHICLE_LICENSE_ERROR: 'License is required'

}

export const FIELD_STATUSES = {
    ERROR: 'error'
}

export const ADMIN_ROLE = 'Super Admin'
export const APP_ADMIN_ROLE = 'App Admin'

export const SCHOOL_ROLE = 'School'
export const GROUP_ROLE = 'Group'
export const PARENT_ROLE = 'Parent'

export const CONTACT_INFO_NOT_SHARED = 'Not Shared'
export const CONTACT_INFO_SHARED = 'Shared'
export const INTERESTED_IN_BIKING = 'Biking'
export const INTRESTED_IN_CARPOOLING = 'Carpooling'
export const INTERESTED_IN_WALKING = 'Walking'
export const NOT_PROVIDED = 'Not Provided'
export const AVAILABLE_FOR_CARPOOLS = 'Available '
export const NOT_AVAILABLE_FOR_CARPOOLS = 'Not Available '
export const NO_SCHOOL = 'No School'
export const ADMIN = 'Admin'
export const PARENT = 'Parent'
export const STUDENT = 'Student'
export const FACULTY = 'Faculty'
export const NO_SCHOOL_ID = null
export const INITIAL_PAGE_NUMBER = 1
export const APPROVED = 'Approved'
export const PENDING = 'Pending'
export const NOT_REQUIRED = 'Not Required'
export const INVITED = 'Invited'
export const DENIED = 'Rejected'
export const ALLOWED = 'Allowed'
export const NOT_APPROVED = 'Not Approved'
export const NOT_ALLOWED = 'Not Allowed'
export const SEARCH_TEXT = undefined
export const NOT_APPROVED_USER = 'Pending'
export const APPROVED_USER = 'Approved'
export const DENIED_USER = 'Rejected'
export const PENDING_MSG = '(Pending)'
export const APPROVED_MSG = '(Approved)'
export const DENIED_MSG = '(Rejected)'
export const UNDEFINED_START_DATE = undefined
export const UNDEFINED_END_DATE = undefined
export const ALL_SCHOOL = 'all'
export const ALL_SCHOOL_MSG = 'All Schools'
export const DISPLAY_FORMAT_DATE = 'D MMMM YYYY'
export const START_CALENDER_FORMAT = 'DD/MM/YYYY'
export const IN_CSV = true
export const NOT_STARTED_PATIENT = "Not Started"
export const IN_PROGRESS_PATIENT = "In-Progress"
export const COMPLETED_PATIENT = 'Completed'
export const CANCELED_PATIENT = 'Canceled'
export const PICKUP_TYPE = 'Pickup'
export const DROP_OFF_TYPE = 'Drop Off'
export const PICKUP_TYPE_NEW = 'Home to Polling Station'
export const DROP_OFF_TYPE_NEW = 'Polling Station to Home'
export const DEFAULT_DATE_TIME_FORMAT = 'MM/DD/YYYY h:mm A';
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const DEFAULT_TIME_FORMAT = 'h:mm A';
export const NOT_PICKED = 'Not Picked';
export const GOING_TO_PICK = 'Going to Pick';
export const ARRIVED = 'Arrived';
export const PICKED = 'Picked';
export const DROPPED = 'Dropped';
export const WAITING = 'Waiting';


export const DEFAULT_USER_IMAGE = '/imgs/app/default-user-image.png';

export const toolTip = (msg) => {
    return (<Tooltip id='tooltip'>{msg}</Tooltip>)
}

export const extractUserInterests = (biking, carpooling, walking) => {
    let interestList = ''
    if (biking) {
        interestList = `${interestList} ${INTERESTED_IN_BIKING}`
    }

    if (carpooling) {
        interestList = `${interestList} ${INTRESTED_IN_CARPOOLING}`
    }

    if (walking) {
        interestList = `${interestList} ${INTERESTED_IN_WALKING}`
    }

    return interestList
}

export const userIs = (isAdmin) => {
    let userIsList = ''
    if (isAdmin) {
        userIsList = `${userIsList} ${ADMIN}`
    }

    return userIsList
}

export const isValidEmail = (email) => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(email)
}

export const isValidPhone = (phoneNo) => {
    var phoneRe = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g
    return phoneRe.test(phoneNo)
}

export const isValidAddress = (address) => {
    const {street1, city, state, postcode} = address;
    if (!street1 && !city && !state && !postcode) {
        return ERROR_MESSAGES.ADDRESS_REQUIRED_ERROR;
    } else if (!address.street1) {
        return ERROR_MESSAGES.STATE_REQUIRED_ERROR;
    } else if (!address.city) {
        return ERROR_MESSAGES.CITY_REQUIRED_ERROR;
    } else if (!address.state) {
        return ERROR_MESSAGES.STATE_REQUIRED_ERROR;
    } else if (!address.postcode) {
        return ERROR_MESSAGES.ZIP_CODE_REQUIRED_ERROR;
    }
    return undefined;
}

export const STYLE = {
    dialogStyles: {
        width: '50%',
        height: '0 auto',
        marginLeft: '-25%',
        top: '28%',
        left: '53%',
        marginTop: 0
    }
}
export const getProperRoleName = role => {
    if (role === ADMIN_ROLE) {
        return 'Super Admin'
    } else if (role === APP_ADMIN_ROLE) {
        return 'App Admin'
    }
    return ADMIN_ROLE
}

export const isAuthorized = (allowedRoles, currentUserRoles) => {
    return _.includes(allowedRoles, currentUserRoles)
}

export const convertRoleArray = (roles) => roles.filter(({hasRole}) => hasRole).map(({roleName}) => (roleName))

export const isDisabled = (roleOption, roles) => {
    let roleNameArray = []
    roles.forEach(({roleName, hasRole}) => {
        console.log(hasRole)
        if (hasRole) {
            roleNameArray.push(roleName)
        }
    })
    roles = roleNameArray

    if (_.includes(roles, ADMIN_ROLE)) {
        return roleOption === ADMIN_ROLE
    }

    if (_.includes(roles, SCHOOL_ROLE)) {
        return roleOption === SCHOOL_ROLE
    }

    if (_.includes(roles, GROUP_ROLE)) {
        return roleOption === GROUP_ROLE
    }
}

export const isHide = (roleOption, roles) => {
    roles = roles.map(({roleName}) => (roleName))
    return !_.includes(roles, ADMIN_ROLE)
}

/* sample 2 line address
 4 George St
 {suburb} Sydney NSW 2000, Australia
 */
export const getFirstLineForAddress = (location = {}) => {
    const {city = '', state = ''} = location
    let address = _.compact([city, state]);
    return address.join(', ');
}

export const getSecondLineForAddress = (location = {}) => {
    const {postcode = '', country = ''} = location
    let address = _.compact([postcode, country]);
    return address.join(', ');
}

const buildFormData = (formData, data, parentKey) => {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;

        formData.append(parentKey, value);
    }
}

export const jsonToFormData = (data) => {
    const formData = new FormData();

    buildFormData(formData, data);

    return formData;
}


export const getScretSSN = (index, replacement, ssn="000-00-0000") => {
    return ssn.substr(0, index) + replacement + ssn.substr(index + replacement.length);
  }
